import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import ViewPDF from '../../Components/PreEx6/DisplayPDF';
import ValidateContract from '../../Components/PreEx6/ValidateContract';
import TableBase from '../../Components/PreEx6/Table/TableBase';
import { exportToCSV } from '../../Components/PreEx6/pre-ex6.service';
import ViewTAndC from '../../Components/PreEx6/DisplayTAndC';
import ConfirmButton from 'Common/Buttons/ActionConfirmButton';
import Page from 'Common/Layout/Page';

const ReleasePreEx6 = () => {
	document.title = "Contract Management - Contract Release Pre EX6"
	const [active_action, setActiveAction] = useState('');
	const [selected_row, setSelectedRow] = useState({});

	const handleBack = () => setActiveAction('');

	const handleActiveAction = (e, row) => {
		setActiveAction(e.target.id || '');
		setSelectedRow(row);
	};

	switch (active_action) {
		case 'view_pdf': {
			return (
				<>
					<Page title="Contract Release Pre EX6">
						<ViewPDF row={selected_row} handleActive={handleActiveAction} />
						<ConfirmButton onClick={handleBack} text="Back" />
					</Page>
				</>
			);
		}
		case 'view_tAndC': {
			return (
				<>
					<Page title="Contract Release Pre EX6">
						<ViewTAndC row={selected_row} handleActive={handleActiveAction} />
						<ConfirmButton onClick={handleBack} text="Back" />
					</Page>
				</>
			);
		}
		case 'validate_contract': {
			return (
				<>
					<Page title="Contract Release Pre EX6">
						<Grid container justify="center" spacing={0} layout="row">
							<Grid item xs={5} component={Card}>
								<ValidateContract row={selected_row} />
							</Grid>
							<Grid item xs={7} component={Card}>
								<ViewPDF row={selected_row} handleActive={handleActiveAction} />
							</Grid>
						</Grid>
						<ConfirmButton onClick={handleBack} text="Back" />
					</Page>
				</>
			);
		}
		case 'export_excel': {
			exportToCSV(selected_row);
			setActiveAction('');
			break;
		}
		case '':
		default:
			return (
				<>
					<Page title="Contract Release Pre EX6">
						<TableBase handleActive={handleActiveAction} />
					</Page>
				</>
			);
	}
};

export default ReleasePreEx6;
